import React, { Component, createRef } from "react";
import { withRouter } from "react-router-dom";
import axios from "axios";
import { getApiHeader, getApiHeaderGuest, setUserSession } from "../../../../utils/CommonFunctions";
import DropIn from "braintree-web-drop-in-react";
import swal from "sweetalert";
import PageLoader from "../../../Loader/loader";
import SignatureCanvas from 'react-signature-canvas';

const SERVER_URL = process.env.REACT_APP_SERVER_URL;

class Payments extends Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: false,
            agreeToTerms: false,
            agreeDirectDebit: false,
            clientToken: "",
            hideButton: false,

            formData: {
                agreeToTerms: false,
                agreeToPrivacy: false,
                signature: '',
                activation_id: "",
                paramName: '',
                paramValue: '',
                address: "",
                password: "",
                c_password: "",
                addres_prop: "",
            },

            errors: {},
            isSubmitting: false,
            hasSignature: false,
            signatureData: null, 
            customer_details: "",
            payment_details: "",
            addressedit: 0,
            common_data: "",

        };
        this.instanceRef = React.createRef();

        this.signatureRef = createRef();
        this.cleanupViewportListeners = null;
    }

    componentDidMount() {
         if(this.props.cardNeeded){
          this.fetchToken();
         }


        // Handle signature canvas sizing and restoration after mount
        setTimeout(() => {
            if (this.signatureRef.current) {
                const canvas = this.signatureRef.current.getCanvas();
                canvas.style.width = '100%';
                canvas.style.height = '150px';

                // Restore signature if it exists
                if (this.state.signatureData) {
                    try {
                        this.signatureRef.current.fromData(this.state.signatureData);
                    } catch (error) {
                        console.warn('Failed to restore signature on mount:', error);
                    }
                }
            }
        }, 100);

        // Add viewport change listeners for mobile
        this.addViewportListeners();
    }

    fetchToken = async () => {
        try {
            this.setState({loading:true});
            const headers = await getApiHeader();
            const response = await axios.get(`${SERVER_URL}payments/get-client-token`, { headers });
            this.setState({ clientToken: response.data.data.clientToken });
        } catch (error) {
          this.setState({loading:false});
        } finally {
           this.setState({loading:false});
        }
    };

    handlecheckTermAndContition = (e) => {
        const isChecked = e.target.checked;
        this.setState((prevState) => ({
            agreeToTerms: isChecked,
            errors: {
                ...prevState.errors,
                agreeToTerms: isChecked ? "" : "Please agree to the Terms & Conditions."
            }
        }));
    };

    handlecheckDirectDebit = (e) => {
        const isChecked = e.target.checked;
        this.setState((prevState) => ({
            agreeDirectDebit: isChecked,
            errors: {
                ...prevState.errors,
                agreeDirectDebit: isChecked ? "" : "Please agree to the Direct Debit Policy."
            }
        }));
    };

    // Validate everything before touching Braintree / the API
    validateForm = () => {
        const errors = {};

        if (!this.state.agreeToTerms) {
            errors.agreeToTerms = "Please agree to the Terms & Conditions.";
        }

        if (!this.state.agreeDirectDebit) {
            errors.agreeDirectDebit = "Please agree to the Direct Debit Policy.";
        }

        if (!this.state.hasSignature) {
            errors.signature = "Please provide your signature";
        }

        return errors;
    };

    buy = async (e) => {
        e.preventDefault();

        const errors = this.validateForm();
        if (Object.keys(errors).length > 0) {
            this.setState({ errors });
            return;
        }

        // Get the signature image (white background PNG) before starting payment
        const signatureImage = this.getSignatureImage();
        if (!signatureImage) {
            this.setState((prevState) => ({
                errors: { ...prevState.errors, signature: "Please provide your signature" }
            }));
            return;
        }

        this.setState({
            isSubmitting: true,
            formData: {
                ...this.state.formData,
                signature: signatureImage
            }
        });
        this.setState({loading:true});

        try {
            let nonce = null 
              if(this.props.cardNeeded){
                  const { nonce: generatedNonce } = await this.instanceRef.current.requestPaymentMethod();
                  nonce = generatedNonce
              }
            const requestData = {
                mobile_number:this.props.mobileNumber,
                plan_id:this.props.planId, 
                session_id: this.props.sessionId,
                nonce: nonce,
                termsCheck: this.state.agreeToTerms,
                directDebitCheck: this.state.agreeDirectDebit,
                signature: signatureImage,
            };

    
            let headers = await getApiHeader();
            const response = await axios.post(`${SERVER_URL}postpaid/so-smo-pr-cp`, requestData, { headers });

            if (response.status === 200) {
                if (response.data?.data?.token && response.data?.data?.user) {
                    setUserSession(response.data?.data?.token, response.data?.data?.user);
                    this.setState({hideButton:true})
                   this.setState({loading:false});
                    swal({
                        text: response.data.message,
                        allowOutsideClick: false,
                        closeOnClickOutside: false,
                        icon: "success"
                    }).then(() => {
                        swal({
                            text: "Thank you for choosing Telsim!",
                            buttons: false,
                            closeOnClickOutside: false,
                            closeOnEsc: false,
                            icon: "success"
                        }).then(()=>{
                              window.location.replace("my-service-list");
                        }) ;
                    });
                } else {
                    this.setState({hideButton:true})
                    swal({
                        text: response.data.message,
                        allowOutsideClick: false,
                        closeOnClickOutside: false,
                        icon: "success"
                     }).then(()=>{
                              window.location.replace("my-service-list");
                            

                     })
                    
                }
            }
        } catch (error) {
            this.setState({loading:true});
            this.setState({ isSubmitting: false });

            const serverMessage = error?.response?.data?.message;

            if (serverMessage) {
                swal({
                    text: serverMessage,
                    allowOutsideClick: false,
                    closeOnClickOutside: false,
                    icon: "error"
                })
                 .then(() => {
                      window.location.replace("my-service-list");
                });
            } else {
                swal({
                    text: error?.message || "Something went wrong. Please try again.",
                    allowOutsideClick: false,
                    closeOnClickOutside: false,
                    icon: "error"
                });
            }
        } finally {
            this.setState({ isSubmitting: false });
            this.setState({loading:true});
        }
    };

   
    addViewportListeners = () => {
        let timeoutId;
        const handleViewportChange = () => {
            clearTimeout(timeoutId);
            timeoutId = setTimeout(() => {
                if (this.signatureRef.current && this.state.signatureData) {
                  
                    try {
                        this.signatureRef.current.fromData(this.state.signatureData);
                    } catch (error) {
                        console.warn('Failed to restore signature:', error);
                    }
                }
            }, 300); 
        };

        window.addEventListener('resize', handleViewportChange);
        window.addEventListener('orientationchange', handleViewportChange);

        // Store cleanup function
        this.cleanupViewportListeners = () => {
            window.removeEventListener('resize', handleViewportChange);
            window.removeEventListener('orientationchange', handleViewportChange);
            clearTimeout(timeoutId);
        };

        // Enhanced iOS Safari detection and handling
        const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent) ||
            (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);

        if (isIOS) {
            let initialViewportHeight = window.innerHeight;
            let keyboardDetectionTimeout;

            const handleIOSViewportChange = () => {
                clearTimeout(keyboardDetectionTimeout);

                keyboardDetectionTimeout = setTimeout(() => {
                    const currentViewportHeight = window.innerHeight;
                    const heightDifference = initialViewportHeight - currentViewportHeight;

                    // If height decreased significantly, keyboard is likely open
                    if (heightDifference > 150) {
                        // Keyboard opened - preserve current signature
                        if (this.signatureRef.current && !this.signatureRef.current.isEmpty()) {
                            try {
                                const currentSignatureData = this.signatureRef.current.toData();
                                this.setState({ signatureData: currentSignatureData });
                            } catch (error) {
                                console.warn('Failed to save signature data:', error);
                            }
                        }
                    } else if (heightDifference < 50) {
                        // Keyboard closed - restore signature after a delay
                        setTimeout(() => {
                            if (this.signatureRef.current && this.state.signatureData) {
                                try {
                                    this.signatureRef.current.fromData(this.state.signatureData);
                                } catch (error) {
                                    console.warn('Failed to restore signature on iOS:', error);
                                }
                            }
                        }, 200);
                    }
                }, 100);
            };

            window.addEventListener('resize', handleIOSViewportChange);

            // Update cleanup function to include iOS listeners
            const originalCleanup = this.cleanupViewportListeners;
            this.cleanupViewportListeners = () => {
                originalCleanup();
                window.removeEventListener('resize', handleIOSViewportChange);
                clearTimeout(keyboardDetectionTimeout);
            };
        }
    };

    componentWillUnmount() {
        // Cleanup event listeners to prevent memory leaks
        if (this.cleanupViewportListeners) {
            this.cleanupViewportListeners();
        }
    }

    handleInputChange = (e) => {
        const { name, value, type, checked } = e.target;
        const inputValue = type === 'checkbox' ? checked : value;

        this.setState((prevState) => ({
            formData: {
                ...prevState.formData,
                [name]: inputValue
            },
            errors: {
                ...prevState.errors,
                [name]: ''
            }
        }));
    };

    // Function to compress/resize signature image
    compressSignatureImage = (canvas) => {
        // Check if canvas is empty first
        if (this.signatureRef.current.isEmpty()) {
            return null;
        }

        // Create a temporary canvas with the same dimensions initially
        const tempCanvas = document.createElement('canvas');
        const tempCtx = tempCanvas.getContext('2d');

        // Set the same dimensions as original to preserve quality
        tempCanvas.width = canvas.width;
        tempCanvas.height = canvas.height;

        // Set white background explicitly
        tempCtx.fillStyle = 'white';
        tempCtx.fillRect(0, 0, tempCanvas.width, tempCanvas.height);

        // Draw the signature on top of white background
        tempCtx.drawImage(canvas, 0, 0);

        // Return as PNG with good quality (PNG preserves transparency better than JPEG)
        return tempCanvas.toDataURL('image/png', 0.9);
    };

    // Alternative method - Get signature without compression (recommended)
    getSignatureImage = () => {
        if (!this.signatureRef.current || this.signatureRef.current.isEmpty()) {
            return null;
        }

        const canvas = this.signatureRef.current.getCanvas();

        // Create a new canvas with white background
        const newCanvas = document.createElement('canvas');
        const newCtx = newCanvas.getContext('2d');

        newCanvas.width = canvas.width;
        newCanvas.height = canvas.height;

        // Fill with white background
        newCtx.fillStyle = 'white';
        newCtx.fillRect(0, 0, newCanvas.width, newCanvas.height);

        newCtx.drawImage(canvas, 0, 0);

        return newCanvas.toDataURL('image/png');
    };

    // Enhanced signature end handler with data preservation
    handleSignatureEnd = () => {
        if (!this.signatureRef.current.isEmpty()) {
            try {
                // Save the signature stroke data for restoration
                const signatureData = this.signatureRef.current.toData();
                this.setState((prevState) => ({
                    hasSignature: true,
                    signatureData: signatureData, // Store the signature data
                    errors: {
                        ...prevState.errors,
                        signature: ""
                    }
                }));
            } catch (error) {
                console.warn('Failed to save signature data:', error);
                // Fallback - just mark as having signature
                this.setState((prevState) => ({
                    hasSignature: true,
                    errors: {
                        ...prevState.errors,
                        signature: ""
                    }
                }));
            }
        }
    };

    // Enhanced clear signature with data cleanup
    clearSignature = () => {
        if (this.signatureRef.current) {
            this.signatureRef.current.clear();
        }
        this.setState((prevState) => ({
            hasSignature: false,
            signatureData: null, // Clear stored signature data
            errors: {
                ...prevState.errors,
                signature: ''
            }
        }));
    };

    componentDidUpdate(prevProps) {
        if (prevProps.customer_details !== this.props.customer_details) {
            const customerAddress = this.props.customer_details?.address;

            this.setState(prevState => ({
                formData: {
                    ...prevState.formData,
                    address: customerAddress
                }
            }));
        }
    }

    render() {
        const { data  } = this.props;

        


        return (
            <div className="post-paid-common-container">
                <div className="container" style={{ background: "none" }}>
                    <div className="row justify-content-center">
                        <div className="col-12 col-md-8 col-lg-12">
                            <div className="card post-paid-common-card">

                                <div className="post-paid-common-form">
                                    <div className="row">

                                        {/* Order Details */}
                                        <div className="col-lg-9 col-md-12 col-sm-12">
                                            <div className="order-details-table">
                                                <h3 className="post-paid-common-section-title" style={{marginBottom:"6px"}}>Order Details</h3>
                                                <table className="table  post-paid-table-data">
                                                    <tbody>

                                                        <>
                                                            <tr>
                                                                <th style={{ fontSize: '14px', fontWeight: '600' }}>Plan Name :</th>
                                                                <td style={{ fontSize: '15px', fontWeight: '500' }}> {this.props.data.plan_name}</td>
                                                            </tr>
                                                            <tr>
                                                                <th style={{ fontSize: '14px', fontWeight: '600' }}>Plan Amount :</th>
                                                                <td style={{ fontSize: '15px', fontWeight: '500' }}> {this.props.data.plan_amount}</td>
                                                            </tr>
                                                            <tr>
                                                                <th style={{ fontSize: '14px', fontWeight: '600' }}>Total Amount :</th>
                                                                <td style={{ fontSize: '15px', fontWeight: '500' }}> {this.props.data.plan_amount}</td>
                                                            </tr>
                                                        </>
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>

                                        {/* Divider */}
                                         {this.props.cardNeeded&&(
                                            <>
                                             <h3 className="" style={{marginBottom:"16px", fontSize:"16px"}}>Payment</h3>
                                        <div className="col-lg-1 d-flex justify-content-center align-items-center">
                                            <div style={{ width: "2px", height: "100%", backgroundColor: "#ccc" }}></div>
                                        </div>

                                        {/* Payment Info */}
                                        <div className="col-lg-12 col-md-12 col-sm-12">
                                            <div className="personal-info-table">
                                                <h3 className="post-paid-common-section-title">{}</h3>
                                                {this.state.clientToken && (
                                                    <DropIn
                                                        options={{ authorization: this.state.clientToken }}
                                                        onInstance={(instance) => (this.instanceRef.current = instance)}
                                                    />
                                                )}

                                                <p style={{ fontWeight: '400', textAlign: 'justify' }}>Your card will be charged 1 AUD for card preauthorization. This pending transaction will be voided by your bank automatically within 7-14 business days. Payment method can be updated anytime in Telsim My Account.</p>
                                            </div>
                                        </div>
                                            
                                            </>
                                         )}

                                        {/* Enhanced Signature Pad */}
                                        <div className="mb-3 mt-3" style={{marginTop:"10px"}}>
                                            <label className="form-label fw-bold">Digital Signature<span style={{ color: "red" }}>* </span></label>
                                            <div
                                                className="border rounded signature-container"
                                                style={{
                                                    backgroundColor: '#fff',
                                                    maxWidth: '500px',
                                                    height: '150px',
                                                    touchAction: 'none',
                                                    position: 'relative',
                                                    overflow: 'hidden'
                                                }}
                                            >
                                                <SignatureCanvas
                                                    ref={this.signatureRef}
                                                    penColor="black"
                                                    dotSize={1}
                                                    minWidth={0.5}
                                                    maxWidth={2}
                                                    velocityFilterWeight={0.7}
                                                    minDistance={5}
                                                    throttle={16}
                                                    canvasProps={{
                                                        className: 'signature-canvas',
                                                        style: {
                                                            backgroundColor: '#fff',
                                                            width: '100%',
                                                            height: '150px',
                                                            border: '1px dashed #ccc',
                                                            touchAction: 'none',
                                                            display: 'block'
                                                        }
                                                    }}
                                                    onEnd={this.handleSignatureEnd}
                                                />
                                            </div>

                                            {this.state.errors.signature && <div className="post-paid-common-error">{this.state.errors.signature}</div>}

                                            <div className='mb-2'>
                                                <button
                                                    type="button"
                                                    className="btn btn-md btn-danger mt-2"
                                                    onClick={this.clearSignature}
                                                >
                                                    Clear Signature
                                                </button>
                                            </div>
                                        </div>

                                        {/* Terms & Submit */}
                                        <div className="post-paid-common-section">
                                            <div className="mb-3">
                                                <div className="form-check">
                                                    <input
                                                        type="checkbox"
                                                        name="agreeToPrivacy"
                                                        checked={this.state.agreeToTerms}
                                                        onChange={this.handlecheckTermAndContition}
                                                        className="form-check-input post-paid-common-checkbox"
                                                        id="agreeToPrivacy"
                                                    />
                                                    <label className="form-check-label post-paid-common-checkbox-label" htmlFor="agreeToPrivacy">
                                                        I agree to Telsim’s <a href="https://www.telsim.com.au/standard-form-of-agreement-sim-only-plans" target="_blank"> Standard Form of Agreement</a>  <span style={{ color: "red" }}> *</span> and <a href="https://www.telsim.com.au/critical-information-summary/telsim-upfront-mobile-plans" target="_blank"> Critical Information Summary</a>  <span style={{ color: "red" }}> *</span>.
                                                    </label>
                                                </div>
                                                {this.state.errors.agreeToTerms && (
                                                    <div className="post-paid-common-error">
                                                        {this.state.errors.agreeToTerms}
                                                    </div>
                                                )}
                                            </div>

                                            <div className="mb-3">
                                                <div className="form-check">
                                                    <input
                                                        type="checkbox"
                                                        name="agreeToDebit"
                                                        checked={this.state.agreeDirectDebit}
                                                        onChange={this.handlecheckDirectDebit}
                                                        className="form-check-input post-paid-common-checkbox"
                                                        id="agreeToDebit"
                                                    />
                                                    <label className="form-check-label post-paid-common-checkbox-label" htmlFor="agreeToDebit" style={{ textAlign: 'justify' }}>
                                                        I authorise Kangaroo Telecom Pty Ltd trading as Telsim Australia (ABN: 84 628 098 966), and its appointed payment processor Braintree (a PayPal service), to debit payments from my nominated payment method as per the agreed billing schedule. These debits are for the payment of my Telsim Mobile Plan Services and may vary in amount depending on the selected plan and usage.
                                                    </label>
                                                    <p>By signing this form: </p>
                                                    <ul style={{ textAlign: 'justify' }}>
                                                        <li>I acknowledge that I have read and understood the Telsim Direct Debit Service Agreement.</li>
                                                        <li>I authorise Telsim Australia and Braintree to debit my account in accordance with the agreement.</li>
                                                        <li>I understand that dishonour fees may apply if funds are insufficient.</li>
                                                        <li>I will notify Telsim of any change to these account details or cancellation of this authority.</li>
                                                    </ul>
                                                </div>
                                                {this.state.errors.agreeDirectDebit && (
                                                    <div className="post-paid-common-error">
                                                        {this.state.errors.agreeDirectDebit}
                                                    </div>
                                                )}
                                            </div>

                                            {!this.state.hideButton && (
                                                <button
                                                    type="button"
                                                    disabled={this.state.isSubmitting}
                                                    className="btn post-paid-common-submit-btn"
                                                    onClick={this.buy}
                                                >
                                                    {this.state.isSubmitting ? (
                                                        <>
                                                            <div className="post-paid-common-spinner d-inline-block me-2"></div>
                                                            Processing...
                                                        </>
                                                    ) : (
                                                        "Submit & Activate"
                                                    )}
                                                </button>
                                            )}

                                        </div>

                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default withRouter(Payments);